import { useQuery } from "@tanstack/react-query";
import { api } from "../api/client";
import { useAppStore } from "../store";

export function useIsFirstTimeUser() {
  const spaceId = useAppStore((s) => s.currentSpaceId);
  const { data: tasks, isLoading } = useQuery({
    queryKey: ["tasks", spaceId, "all"],
    queryFn: () => api.tasks.list({ spaceId }),
  });
  return {
    isFirstTime: !isLoading && Array.isArray(tasks) && tasks.length === 0,
    isLoading,
  };
}
